import { toKenyanMobile } from '@chukua/common';

const MESSAGE = 'Enter a Kenyan mobile number, like 0712 345 678';

/** The check `kePhoneSchema` makes on the server, beside the field: +254 is optional, so 0712 345 678 and 712345678 pass. */
export function kenyanMobileRules({ required, requiredMessage = 'Enter a phone number' }: { required: boolean; requiredMessage?: string }) {
  return [
    ...(required ? [{ required: true, message: requiredMessage }] : []),
    {
      validator: (_: unknown, value: unknown) =>
        !value || (typeof value === 'string' && toKenyanMobile(value)) ? Promise.resolve() : Promise.reject(new Error(MESSAGE)),
    },
  ];
}
